import React from "react";

const ColorModeContext = React.createContext({
  mode: 'light',
  toggleColorMode: () => {},
  setPrimaryColorLight: (_) => {},
  setPrimaryColorDark: (_) => {},
  setAppLogoLight: (_) => {},
  setAppLogoDark: (_) => {},
  setAppLogoFavicon: (_) => {},
  setAppLogoBackgroundLight: (_) => {},
  setAppLogoBackgroundDark: (_) => {},
});

export default ColorModeContext;
